import React, { useRef, useEffect } from 'react';
import { observer } from 'mobx-react';
import { useRouteMatch, useHistory } from 'react-router-dom';
import { FlatButton } from 'nrcs-design-system';
import { mdiDelete, mdiClipboardTextMultipleOutline, mdiMapMarkerPath, mdiDownloadOutline } from '@mdi/js';
import { DeleteElement } from 'cd-eft/components/Design/common/DeleteElement';
import { DownloadProject } from '../DownloadProject/DownloadProject';
import { ProjectActionsVM, IProjectActionsProps } from './ProjectActionsVM';
import stores from '../../../models/Stores';

const appConfig = stores.AppStore.appConfig;

const ProjectActionsComponent = (props: IProjectActionsProps) => {
  const history = useHistory();
  const { url } = useRouteMatch();
  const vm = useRef(new ProjectActionsVM(props, history, url)).current;

  // useEffect(() => {
  //   if (!stores.AppStore.projectsLibraryStore.projectContainerInitializing) {
  //     vm.getAllDesignElementsBySession(props.project.sessionList[0].sessionUuid);
  //   }
  // }, [props.project.sessionList[0].sessionUuid, stores.AppStore.projectsLibraryStore.projectContainerInitializing]);

  return (
    <>
      <FlatButton
        title={'Output'}
        iconLeft={mdiDownloadOutline}
        onClick={vm.handleDownloadProject}
        disabled={!appConfig.projectFlags.enableDownloadProject}
      >
        <span>Output</span>
      </FlatButton>

      {/* 
          <FlatButton
            title={isMobile ? 'Reporting' : undefined}
            iconLeft={mdiFileChartOutline}
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <span>Reporting</span>
          </FlatButton> */}

      <FlatButton
        title={!vm.copied ? 'Copy Link' : 'Copied!'}
        iconLeft={mdiClipboardTextMultipleOutline}
        onClick={vm.handleShareProject}
        disabled={!appConfig.projectFlags.enableCopyLink}
      >
        {!vm.copied ? <span>Copy Link</span> : <span>Copied!</span>}
      </FlatButton>
      <FlatButton
        title={'Load Project'}
        iconLeft={mdiMapMarkerPath}
        onClick={vm.handleLoadProject}
        disabled={!appConfig.projectFlags.enableLoadProject}
      >
        <span>Load Project</span>
      </FlatButton>

      {/* 
        <FlatButton
          iconLeft={mdiSquareEditOutline}
          onClick={(e) => {
            e.stopPropagation();
            history.push(`${url}/edit-project/${project.projectUuid}`);
          }}
        >
          Edit
        </FlatButton>
        */}

      <FlatButton
        title={'Delete'}
        iconLeft={mdiDelete}
        onClick={vm.handleDeleteProject}
        disabled={!appConfig.projectFlags.enableDeleteProject}
      >
        <span>Delete</span>
      </FlatButton>

      {/* Download Modal */}
      {vm.showDownloadPopup && (
        <DownloadProject
          showDownloadPopup={vm.showDownloadPopup}
          toggleDownloadPopup={vm.toggleDownloadPopup}
          project={vm.project}
        />
      )}

      {/* Delete Modal */}
      {vm.showDeletePopup && (
        <DeleteElement
          trigger={vm.showDeletePopup}
          setTrigger={vm.deletePopupToggle}
          element="project"
          name={vm.project.projectTitle}
          action={vm.deleteProjectAction}
        />
      )}
    </>
  );
};

export const ProjectActions = observer(ProjectActionsComponent);
